import React, {FC, useState} from "react";
import NcImage from "shared/NcImage/NcImage";
import NcModal from "shared/NcModal/NcModal";
import EventTickets from "./EventTickets";
import {OrderEventType} from "data/types";

export interface OrderCardProps {
  className?: string;
  name: string;
  count: string | number;
  thumbnail: string;
  isSubscriber?: boolean;
  id: string;
  isRaffle: boolean;
  type: string;
  order: OrderEventType;
  subscriberImg?: string;
  isPastEvent?: boolean;
}

const OrderCard: FC<OrderCardProps> = ({
  className = "",
  name,
  count,
  thumbnail,
  isSubscriber = false,
  id,
  isRaffle,
  type,
  order,
  subscriberImg,
  isPastEvent = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <NcModal
      key={id}
      modalTitle="Mis Tickets"
      isOpenProp={modalOpen}
      onCloseModal={() => setModalOpen(false)}
      renderTrigger={() => (
        <>
          <div
            className={`flex-shrink-0 relative w-full aspect-w-4 aspect-h-3 h-0 rounded-2xl overflow-hidden group`}
            onClick={() => {
              if (!isPastEvent) setModalOpen(true);
            }}
          >
            <NcImage
              src={thumbnail}
              className="object-cover w-full h-full rounded-2xl"
            />
            <span className="opacity-0 group-hover:opacity-100 absolute inset-0 bg-black bg-opacity-10 transition-opacity"></span>
          </div>
          <div className="mt-4 px-3">
            <h2
              className={`text-base sm:text-sm text-neutral-900 dark:text-neutral-100 font-medium`}
            >
              {name}
            </h2>
            <span
              className={`block mt-2 text-xs text-neutral-6000 dark:text-neutral-400`}
            >
              {count === "0_0" ? "" : count} {!isSubscriber ? "tickets" : ""}
            </span>
          </div>
        </>
      )}
      renderContent={() => (
        <EventTickets
          orderId={id}
          isRaffle={isRaffle}
          type={type}
          order={order}
          subscriberImg={subscriberImg}
          locality={
            isSubscriber ? (order as any).subscriberList.name : undefined
          }
        />
      )}
    />
  );
};

export default OrderCard;
